import { useMemo } from 'react'
import { vars } from 'ui/styles/vars.css'

import { env } from '../../utils/environment'

const [, ruby, sapphire, diamond] = env.stakingThresholds

export const StakingBadgeConfig = {
    neutral: {
        type: 'neutral' as const,
        name: 'Neutral',
        staker: '',
        description: '0 $TOWNS',
        threshold: 0,
        colors: {
            start: vars.color.foreground.gray2,
            end: vars.color.foreground.gray2,
        },
    },
    base: {
        type: 'base' as const,
        name: 'Base',
        staker: 'Staker',
        description: 'some $TOWNS',
        threshold: 0.001,
        colors: {
            start: vars.color.foreground.gray2,
            end: vars.color.foreground.gray2,
        },
    },
    ruby: {
        type: 'ruby' as const,
        name: 'Ruby',
        staker: 'Ruby Staker',
        description: `${ruby} $TOWNS`,
        threshold: ruby,
        colors: {
            start: '#FF258B',
            end: '#FA5189',
        },
    },
    sapphire: {
        type: 'sapphire' as const,
        name: 'Sapphire',
        staker: 'Sapphire Staker',
        description: `${sapphire} $TOWNS`,
        threshold: sapphire,
        colors: {
            start: '#1C5BB2',
            end: '#8151FA',
        },
    },
    diamond: {
        type: 'diamond' as const,
        name: 'Diamond',
        staker: 'Diamond Staker',
        description: `${diamond} $TOWNS`,
        threshold: diamond,
        colors: {
            start: '#B7FFD8',
            end: '#43EBFF',
        },
    },
} as const
const isStakingBadge = (type: string): type is StakingBadgeType => {
    return type in StakingBadgeConfig
}

export const isStakingBadgeWithIcon = (type: string) => {
    return isStakingBadge(type) && StakingBadgeConfig[type].threshold > 0
}

export type StakingBadgeType = keyof typeof StakingBadgeConfig
export type StakingBadge = (typeof StakingBadgeConfig)[StakingBadgeType]

// Hook to get badge information based on amount
export const useStakingBadge = (amount: number): StakingBadge => {
    return useMemo(() => {
        if (amount >= diamond) {
            return StakingBadgeConfig.diamond
        }
        if (amount >= sapphire) {
            return StakingBadgeConfig.sapphire
        }
        if (amount >= ruby) {
            return StakingBadgeConfig.ruby
        }
        if (amount > 0) {
            return StakingBadgeConfig.base
        }
        return StakingBadgeConfig.neutral
    }, [amount])
}
